module.exports = __webpack_public_path__ + "portal/static/img/scb.a416a95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-bank/scb.png
// module id = ZgF5
// module chunks = 67